module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Picker-b68a4e9cc6aebe7b0219968cb47e7b4d.svg";